import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/daily/course/schedules', config);
}

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/daily/course/schedules/' + id);
}

const getOfStudent= async (id) =>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/daily/course/schedules/student/' +id);
}

const store = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/daily/course/schedules', formData);
}

const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/daily/course/schedules/' + id, formData);
}

const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/daily/course/schedules/' + id);
}

const getInstructor = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/daily/course/schedules/instructor', config);
}

const fileImport = async (semesterId, file) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/daily/course/schedules/import/' + semesterId, file);
}

const excelExport = (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/daily/course/schedules/excel-export',{...config,responseType:"arraybuffer"});
}

export default {
    getAll,
    store,
    update,
    get,
    getOfStudent,
    del,
    getInstructor,
    fileImport,
    excelExport
}
